// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === "7888") return "css/design_system-54c57a9f964d6288.css";
if (chunkId === "1692") return "css/1692-c4fb6e03132e1a07.css";
if (chunkId === "4662") return "css/4662-44eccc0403d5f3f3.css";
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {"2429": "a73d2fa285645c40","3023": "ff4fe74b9ae62267","3628": "a7d2736837bd50d2","4218": "47a8b89e3adc0bc7",}[chunkId] + ".css"
}